import { useRecordContext, useTranslate } from 'react-admin'

const TranslateField = (props: any) => {
  const { translate } = props
  const record = useRecordContext(props)

  const t = useTranslate()
  if (!record) {
    return null
  }
  return <span>{t(eval('`' + translate + '`'))}</span>
}

export default TranslateField
